import { constants } from "@thecb/components";
import React, { forwardRef } from "react";
import styled from "styled-components";

const StyledDragHandle = styled.button`
  background: transparent;
  border none;
  cursor: grab !important;
  border-radius: 5px;
  
  &:hover {
    background-color: ${constants.colors.GRECIAN_GREY};
  }
`;

const DragHandle = forwardRef<HTMLButtonElement>((props, ref) => (
  <StyledDragHandle ref={ref} {...props} tabIndex={0}>
    <svg viewBox="0 0 20 20" width="12">
      <path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"></path>
    </svg>
  </StyledDragHandle>
));

export default DragHandle;
